import {ResourceData} from "../common/resource/resource-service";
import {ICompRule} from "./comprule-models.";

export class CompRuleData extends ResourceData<ICompRule> {
    constructor() {
        super("/v5/rule");
    }
}
